import { render, staticRenderFns } from "./VerseOfTheDayWidget.vue?vue&type=template&id=14d6f397&scoped=true&"
import script from "./VerseOfTheDayWidget.vue?vue&type=script&lang=js&"
export * from "./VerseOfTheDayWidget.vue?vue&type=script&lang=js&"
import style0 from "./VerseOfTheDayWidget.vue?vue&type=style&index=0&id=14d6f397&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d6f397",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
